<template>
  <div class="text-center d-flex flex-column align-items-center margin-container-error">
    <img src="@/assets/img/error.png" width="128" class="mx-auto" />
    <p class="c-deep fs-52 fw-600 my-error">
      {{ $l.detectLanguage('invalidQrTitle') }}
    </p>
    <p class="c-primary fs-38 fw-600 mb-40">
      {{ $l.detectLanguage('invalidQrDesc1') }}
      <span class="c-pink-dokter fw-700">{{ $l.detectLanguage(nameKiosk) }}</span>
      {{ $l.detectLanguage('invalidQrDesc2') }}
    </p>
    <div
      class="row text-left c-pink-dokter list-dokter-antrian w-100"
    >
      <div class="col-12 padding-dokter-select">
        <p class="fs-32 fw-700 c-primary mb-2 text-center">
          {{ $l.detectLanguage('yourApptText') }}
        </p>
        <template v-for="item, index in dokter" :key="index">
          <card-dokter-appointment :class-border="index < dokter.length - 1" :detail-dokter="mapDokter(item)"/>
        </template>
      </div>
    </div>
    <button-time-out
      class="fs-32 width-200"
      :time="timeOut"
      @click="goToRoute()"
    />
  </div>
</template>

<script>
import ButtonTimeOut from '../Button/ButtonTimeOut.vue'
import CardDokterAppointment from './CardDokterAppointment.vue'
import KioskAntrianMapper from '@/mappers/KioskAntrianMapper'

export default {
  components: {
    ButtonTimeOut,
    CardDokterAppointment
  },
  props: {
    dokter: {
      type: Array,
      default: () => []
    },
    timeOut: {
      type: Number,
      default: 20
    },
    jenisPembayaran: {
      type: String,
      default: ''
    }
  },
  computed: {
    nameKiosk () {
      if (this.jenisPembayaran === 'ASURANSI') return 'kioskAsuransi'
      else return 'kioskPribadi'
    }
  },
  methods: {
    mapDokter (item) {
      return KioskAntrianMapper.mapDokterCheckBox(item)
    },
    goToRoute () {
      window.machineKiosk.send({
        type: 'button:ok'
      })
    }
  }
}
</script>
